<script>
import { formatTitleForEnvironment } from './title.helpers'

export default {
    name: 'vue-title',
    props: ['title', 'brand'],

    watch: {
        title: {
            immediate: true,
            handler() {
                this.updateTitle();
            }
        }
    },

    methods: {

        updateTitle() {
            window.$bus.$emit('title-change', this.title);
            const title = `${this.title}${this.brand ? " | Tractus Passport" : ''}`;
            document.title = formatTitleForEnvironment(title);
        }
    },

    render () {
    }
}
</script>
